<template>
    <div class="el-copy" @click="copyToClipboard">
        <slot></slot>
        <i class="el-icon-copy-document el-copy-hover"></i>
    </div>
</template>

<script>
export default {
    methods: {
        copyToClipboard() {
            const text = this.$slots.default[0].text;
            const input = document.createElement('input');
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);

            this.$message({
                message: '复制成功',
                type: 'success'
            });
        }
    }
}
</script>

<style lang="scss">
.el-copy {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-copy-hover {
        display: none;
    }
}

.el-copy:hover {
    .el-copy-hover {
        display: block;
    }
}
</style>